import { render, staticRenderFns } from "./AddTelegram.vue?vue&type=template&id=c7de1622"
import script from "./AddTelegram.vue?vue&type=script&lang=js"
export * from "./AddTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports